<template>
  <div class="split-container">
    <!-- Linke Spalte: Login-Bereich -->
    <div class="left-section">
      <div class="login-container">
        <!-- Überschrift ändern oder beibehalten -->
        <h2>LOGIN</h2>
        <!-- Neu hinzugefügter Text -->
        <p>Zugang zu deinem Projektdashboard und Dateien.</p>

        <form @submit.prevent="login">
          <div class="form-group">
            <label for="username">Benutzername:</label>
            <input type="text" id="username" v-model="username" required>
          </div>
          <div class="form-group">
            <label for="password">Passwort:</label>
            <input type="password" id="password" v-model="password" required>
          </div>
          <!--<div class="form-group checkbox">
            <input type="checkbox" id="simulate" v-model="simulate">
            <label for="simulate">Simulation aktivieren (nur dev-Profil)</label>
          </div>-->
          <button type="submit" class="login-btn">Einloggen</button>
        </form>
        <div class="message" :class="messageClass" v-if="message">{{ message }}</div>
      </div>
    </div>

    <!-- Rechte Spalte: Diplomarbeitsdatenbank -Text -->
    <div class="right-section">
      <h1>Diplomarbeitsdatenbank!</h1>
    </div>
  </div>
</template>

<script>
import { useAuthenticationStore } from '@/stores/useAuthStore'

export default {
  name: 'LoginSimulation',
  data() {
    return {
      username: '',
      password: '',
      simulate: false,
      message: '',
      messageClass: ''
    }
  },
  methods: {
    async login() {
      this.message = ''
      try {
        const csrfResponse = await fetch(`${process.env.VUE_APP_BACKEND}/auth/csrf-token`, {
          method: 'GET',
          credentials: 'include'
        })
        if (!csrfResponse.ok) {
          throw new Error('CSRF-Token konnte nicht abgerufen werden.')
        }
        const csrfData = await csrfResponse.json()
        const csrfToken = csrfData.token
        const csrfHeaderName = csrfData.headerName

        const loginPayload = {
          username: this.username.trim(),
          password: this.password,
          simulate: this.simulate
        }

        const loginResponse = await fetch(`${process.env.VUE_APP_BACKEND}/auth/login`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            [csrfHeaderName]: csrfToken
          },
          credentials: 'include',
          body: JSON.stringify(loginPayload)
        })

        if (!loginResponse.ok) {
          const errorText = await loginResponse.text()
          throw new Error(errorText || 'Login fehlgeschlagen.') 
        }

        const authData = await loginResponse.json()
        const authStore = useAuthenticationStore()
        authStore.setAuthentication({ ...authData, samAccount: this.username.trim() })

        this.message = 'Login erfolgreich!'
        this.messageClass = 'success'

        const userResponse = await fetch(`${process.env.VUE_APP_BACKEND}/diplomdb/api/users/${this.username.trim()}`, {
          method: 'GET',
          credentials: 'include'
        })
        if (!userResponse.ok) {
          const errorText = await userResponse.text()
          throw new Error(errorText || 'Fehler beim Abrufen der Benutzerdaten.')
        }
        const userData = await userResponse.json()
        authStore.setCN(userData.cn)

        this.$router.push('/homepage')
      } catch (error) {
        this.message = 'Fehler: ' + error.message
        this.messageClass = 'error'
      }
    }
  }
}
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
  font-family: Arial, sans-serif;
}

.split-container {
  display: flex;
  height: 100vh;
}

.left-section {
  flex: 1;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.right-section {
  flex: 1;
  background: linear-gradient(90deg, #cedaff 0%, #e3f4ff 100%);
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-container {
  width: 100%;
  max-width: 600px;
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  margin: 0;
}
.login-container h2 {
  margin-bottom: 20px;
  text-align: center;
}
.login-container p {
  margin-bottom: 20px;
  text-align: center;
  color: #666;
}
p {
  font-size: 15px;
}
.form-group {
  margin-bottom: 15px;
}
label {
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
}
input[type="text"],
input[type="password"] {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 3px;
  font-family: 'DM Sans', sans-serif;
}
.form-group.checkbox {
  display: flex;
  align-items: center;
}
.form-group.checkbox input[type="checkbox"] {
  margin-right: 10px;
}
.login-btn {
  width: 100%;
  padding: 10px;
  background-color: #007bff;
  border: none;
  border-radius: 3px;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  font-family: 'DM Sans', sans-serif;
}
.login-btn:hover {
  background-color: #0056b3;
}
.message {
  margin-top: 15px;
  text-align: center;
  font-weight: bold;
}
.message.error {
  color: #d9534f;
}
.message.success {
  color: #5cb85c;
}
</style>